import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import Categories from '../components/Categories';
import ProductList from '../components/ProductList';
import { fetchData } from '../function/util';

function Home() {
  const [data, setData] = React.useState([]);
  useEffect(()=>{
    fetchData("featured")
    .then((res) => {
      setData(res);
    })
    .catch((error) => {
      console.error('Error fetching data:', error)
    })
  }, [])

  return (
    <div className='main-content'>
      <Hero />
      <ProductList data={data.featured} title="Featured Products" />
      <Categories collection={data?.collection} />
    </div>
  );
}

export default Home;
